export const contactDict = {
    en: {
      "Query": "Query",
      "Choose": "Choose",
      "General": "General",
      "Rewards Related": "Rewards Related",
      "Surveys Related": "Surveys Related",
      "Subject": "Subject",
      "Please Enter": "Please Enter",
      "Message": "Message",
      "Submit": "Submit",
      "Reset": "Reset",
      "Contact Us" : "Contact Us" ,
      "Success!" : "Success!",
      "Success Message" : "Your query has been successfully submitted. Our team is working diligently to address it, and we will provide a resolution at the earliest opportunity. Thank you for your patience."
    },
    hi: {
      "Query": "सवाल",
      "Choose": "चुनना",
      "General": "सामान्य",
      "Rewards Related": "पुरस्कार से संबंधित",
      "Surveys Related": "सर्वे से संबंधित",
      "Subject": "विषय",
      "Please Enter": "कृपया दर्ज करें",
      "Message": "संदेश",
      "Submit": "जमा करना",
      "Reset": "पुन्ह: सेट करे",
      "Contact Us" : "संपर्क करें",
      "Success!" : "सफलता!",
      "Success Message" : "आपकी क्वेरी सफलतापूर्वक सबमिट कर दी गई है। हमारी टीम इसे संबोधित करने के लिए लगन से काम कर रही है, और हम जल्द से जल्द समाधान प्रदान करेंगे। आपके धैर्य के लिए धन्यवाद।"
    }
};

export const changePasswordDict = {
    en: {
      "Change Password": "Change Password",
      "Current Password": "Current Password",
      "New Password": "New Password",
      "Confirm New Password": "Confirm New Password",
      "Enter...": "Enter...",
      "Passwords Matched": "Passwords matched!",
      "Not Matched": "Not Matched",
      "Change": "Change"
    },
    hi: {
      "Change Password": "पासवर्ड बदलें",
      "Current Password": "वर्तमान पासवर्ड",
      "New Password": "नया पासवर्ड",
      "Confirm New Password": "नए पासवर्ड की पुष्टि करें",
      "Enter...": "दर्ज करें...",
      "Passwords Matched": "पासवर्ड मेल खा गए!",
      "Not Matched": "मेल नहीं खाया",
      "Change": "बदलें"
    }
  };
  